import React from "react";
import { Stack, Typography } from "@mui/material";

interface Customer {
  totalVisits?: string | number | null;
  totalVisitsLifetime?: string | number | null;
  lastVisitedStoreId?: string | null;
}

interface StoreVisitsProps {
  customer: Customer;
}

export const StoreVisits = ({ customer }: StoreVisitsProps) => {
  const formatValue = (value: string | undefined, label: string): string => {
    if (!value) {return `No ${label}`;}
    return value;
  };

  const renderInfoRow = (label: string, value: string | undefined) => (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="body2" fontWeight={600}>{label}:</Typography>
      <Typography variant="body2">{formatValue(value, label)}</Typography>
    </Stack>
  );

  const safeString = (val: string | number | null | undefined): string | undefined => {
    if (val === null || val === undefined) {return undefined;}
    return String(val);
  };

  return (
    <Stack spacing={1}>
      {renderInfoRow("Total Visits", safeString(customer.totalVisits))}
      {renderInfoRow("Total Visits Lifetime", safeString(customer.totalVisitsLifetime))}
      {renderInfoRow("Last Visited Store", safeString(customer.lastVisitedStoreId))}
    </Stack>
  );
};
